import React from 'react'
import {
  Grid,
  Drawer,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { CHOICE_INFO } from './queries'
import { useQuery } from '@apollo/react-hooks'
import CustomTooltip from '../../../../../../components/CustomTooltip'
import decodeJWT from 'jwt-decode'
import _ from 'lodash'

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  dialogStatement: {
    fontSize: 16,
    fontWeight: 600,
  }
}))

function ChoiceInfoDrawer(props) {
  const classes = useStyles()
  const currentUserId = localStorage.getItem('userId')
  const userProfile = decodeJWT(localStorage.getItem('token')).profile

  const { data, loading, error } = useQuery(CHOICE_INFO, {
    variables: {
      choiceId: props.choiceId || 0
    }
  })

  const makeItem = (item) => (
    <ListItem>
      <Grid container justify="space-between" alignItems="center">
        <Grid item xs={ 8 }>
          <ListItemText>
            <Typography align="justify">
              { item }
            </Typography>
          </ListItemText>
        </Grid>
      </Grid>
    </ListItem>
  )

  return (
    <Drawer
      anchor="right"
      open={ !!props.choiceId }
      onClose={ props.closeDialog }
    >
      <div style={{ width: 500, height: '95%', display: 'flex', flexDirection: 'column' }}>
        {
          error && <p>{ error.message }</p>
        }
        {
          loading &&
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress />
            </div>
        }
        {
          !error && !loading && (
          <>
            <DialogTitle id="comment-dialog" className={ classes.dialogTitle }>
              <strong>Conexões</strong>
            </DialogTitle>
            <DialogContent>
              <Typography variant="caption">
                Este item constará nos questionários referentes aos Temas/Tópicos
                e Setores listados abaixo
              </Typography>
              <div style={{ flexGrow: 1, overflowY: 'scroll' }}>
                <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
                  Temas/Tópicos ({ _.get(data, 'choiceInfo.subtopics', []).length })
                </DialogContentText>
                <List dense>
                  { _.get(data, 'choiceInfo.subtopics', []).map(makeItem) }
                </List>
                <DialogContentText color="textPrimary" className={ classes.dialogStatement }>
                  Setores ({ _.get(data, 'choiceInfo.sectors', []).length })
                </DialogContentText>
                <List dense>
                  { _.get(data, 'choiceInfo.sectors', []).map(makeItem) }
                </List>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={ props.closeDialog } color="secondary">
                Fechar
              </Button>
            </DialogActions>
          </>
          )
        }
      </div>
    </Drawer>
  )
}

export default ChoiceInfoDrawer
